// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-agent-issuance-wrapper {
  display: flex;
  margin: 50px 10px;
  flex-direction: column;
  padding: 50px;
}
.manage-agent-issuance-wrapper .smart-image {
  width: 375px;
  height: 263px;
}
.manage-agent-issuance-wrapper .card-information {
  margin: 20px 0px;
}
.manage-agent-issuance-wrapper .card-information .agent-issuance-header-action {
  display: flex;
  gap: 30px;
}
.manage-agent-issuance-wrapper .card-information .card-information-header {
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 10px;
}
.manage-agent-issuance-wrapper .card-information .card-information-sub-header {
  font-size: 25px;
  margin-bottom: 10px;
}
.manage-agent-issuance-wrapper .card-information .transaction-subheader {
  color: white;
  font-size: 18px;
  padding: 0px 15px;
}
.manage-agent-issuance-wrapper .card-information .transaction-subheader .transaction-subheader-link {
  color: #FFFB00;
  text-decoration: underline;
  cursor: pointer;
}
.manage-agent-issuance-wrapper .card-information .card-information-info {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  padding: 10px 50px;
  align-items: center;
}
.manage-agent-issuance-wrapper .card-information .card-information-info .card-information-data {
  display: flex;
  flex-direction: row;
  flex: 0.5 1;
  color: white;
  gap: 20px;
}
.manage-agent-issuance-wrapper .card-information .card-information-info .card-information-data .card-information-data-label {
  font-weight: 800;
}
.manage-agent-issuance-wrapper .manage-agent-action {
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
}
@media screen and (min-width: 768px) {
  .manage-agent-issuance-wrapper .manage-agent-action {
    margin-top: 35px;
  }
}
.manage-agent-issuance-wrapper .manage-agent-action button {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .manage-agent-issuance-wrapper .manage-agent-action button {
    width: 50%;
    margin: 0;
  }
  .manage-agent-issuance-wrapper .manage-agent-action button:first-child {
    width: calc(50% - 15px);
    margin-right: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/agent-issuance/manage-agent-issuance/ManageAgentIssuance.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AACI;EACE,aAAA;EACA,SAAA;AACN;AACI;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;AACN;AACI;EACE,eAAA;EACA,mBAAA;AACN;AACI;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AACN;AAAM;EACE,cAAA;EACA,0BAAA;EACA,eAAA;AAER;AACI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AACN;AAAM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAER;AADQ;EACI,gBAAA;AAGZ;AAME;EACI,aAAA;EACA,eAAA;EACA,gBAAA;AAJN;AAKM;EAJJ;IAKM,gBAAA;EAFN;AACF;AAGM;EACE,WAAA;AADR;AAEQ;EAFF;IAGI,UAAA;IACA,SAAA;EACR;EAAQ;IACE,uBAAA;IACA,kBAAA;EAEV;AACF","sourcesContent":[".manage-agent-issuance-wrapper {\n  display: flex;\n  margin: 50px 10px;\n  flex-direction: column;\n  padding: 50px;\n\n  .smart-image {\n    width: 375px;\n    height: 263px;\n  }\n\n  .card-information {\n    margin: 20px 0px;\n    .agent-issuance-header-action {\n      display: flex;\n      gap: 30px\n    }\n    .card-information-header {\n      font-weight: bold;\n      font-size: 30px;\n      margin-bottom: 10px;\n    }\n    .card-information-sub-header {\n      font-size: 25px;\n      margin-bottom: 10px;\n    }\n    .transaction-subheader {\n      color: white;\n      font-size: 18px;\n      padding: 0px 15px;\n      .transaction-subheader-link {\n        color: #FFFB00;\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n    .card-information-info {\n      display: flex;\n      flex-direction: row;\n      flex: 1;\n      padding: 10px 50px;\n      align-items: center;\n      .card-information-data {\n        display: flex;\n        flex-direction: row;\n        flex: 0.5;\n        color: white;\n        gap: 20px;\n        .card-information-data-label {\n            font-weight:800;\n        }\n\n        .card-information-data-value {\n\n        }\n      }\n    }\n  }\n  .manage-agent-action{\n      display: flex;\n      flex-wrap: wrap;\n      margin-top: 50px;\n      @media screen and (min-width: 768px) {\n        margin-top: 35px;\n      }\n      button{\n        width: 100%;\n        @media screen and (min-width: 768px) {\n          width: 50%;\n          margin:0;\n          &:first-child{\n            width: calc( 50% - 15px );\n            margin-right: 15px;\n          }\n        }\n      }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
